export default __webpack_public_path__ + "static/media/product-13 (1).ac91bff4.jpg";